var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMillennium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 13.4",
    style: {
      enableBackground: "new 0 0 96 13.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.5,4.9H0V4.4h3.5v1.1c0.8-0.9,1.7-1.3,2.9-1.3c0.7,0,1.3,0.2,1.8,0.5C8.5,5,8.6,5.2,8.8,5.7 c0.7-1,1.7-1.5,3-1.5c0.9,0,1.7,0.3,2.1,0.8c0.3,0.4,0.4,1,0.4,2.2v5.5h1.5v0.4h-4.8v-0.4h1.3V7.3c0-1.5,0-1.8-0.4-2.1 c-0.2-0.2-0.5-0.3-0.9-0.3c-0.8,0-1.5,0.4-1.8,1.1C9,6.7,8.9,6.9,8.9,10.3v2.4h1.3v0.4H5.6v-0.4h1.3V7.3c0-1.1-0.1-1.5-0.2-1.8 c-0.2-0.3-0.6-0.5-1-0.5C4.9,4.9,4.2,5.4,3.9,6c-0.3,0.6-0.4,1.7-0.4,4.3v2.4h1.3v0.4H0v-0.4h1.5V4.9z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "16.4,4.4 16.4,4.9 17.9,4.9 17.9,12.7 16.4,12.7 16.4,13.2 21.4,13.2 21.4,12.7 19.9,12.7 19.9,4.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.1,1.7c0,0.7-0.6,1.3-1.3,1.3c-0.7,0-1.2-0.6-1.2-1.3c0-0.7,0.5-1.2,1.2-1.2C19.5,0.4,20.1,1,20.1,1.7"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "21.6,0 21.6,0.4 23.1,0.4 23.1,12.7 21.6,12.7 21.6,13.2 26.5,13.2 26.5,12.7 25.1,12.7 25.1,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26.7,0 26.7,0.4 28.2,0.4 28.2,12.7 26.7,12.7 26.7,13.2 31.7,13.2 31.7,12.7 30.2,12.7 30.2,0  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.1,7.6c0-1.5,0-1.6-0.2-2c-0.2-0.6-0.7-0.9-1.4-0.9c-0.6,0-1.1,0.2-1.4,0.6c-0.3,0.4-0.4,0.8-0.4,1.9v0.5 H38.1z M34.6,8.1v0.6c0,2.2,0,2.7,0.3,3.1c0.3,0.6,1,1,1.8,1c1.4,0,2.5-1,3-2.6h0.5c-0.4,1.9-1.8,3.2-3.6,3.2 c-2.3,0-4.3-2.2-4.3-4.6s2-4.6,4.2-4.6c1.4,0,2.6,0.7,3.3,1.8c0.4,0.6,0.5,1.1,0.6,2.1H34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.6,4.9h-1.5V4.4h3.5v1.2c0.7-0.9,1.6-1.4,2.8-1.4c0.9,0,1.8,0.4,2.3,0.9c0.5,0.6,0.6,1.1,0.6,2.7v4.9h1.5 v0.4H47v-0.4h1.3V9.3c0-2.6-0.1-3.4-0.4-3.9c-0.3-0.4-0.7-0.6-1.1-0.6c-0.6,0-1.3,0.4-1.6,0.9c-0.4,0.6-0.6,1.6-0.6,4.3v2.6h1.3 v0.4h-4.8v-0.4h1.5V4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.7,4.9h-1.5V4.4h3.5v1.2c0.7-0.9,1.6-1.4,2.8-1.4c0.9,0,1.8,0.4,2.3,0.9c0.5,0.6,0.6,1.1,0.6,2.7v4.9h1.5 v0.4h-4.8v-0.4h1.3V9.3c0-2.6-0.1-3.4-0.4-3.9c-0.3-0.4-0.7-0.6-1.1-0.6c-0.6,0-1.3,0.4-1.6,0.9c-0.4,0.6-0.6,1.6-0.6,4.3v2.6h1.3 v0.4h-4.8v-0.4h1.5V4.9z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "63.4,4.4 63.4,4.9 64.9,4.9 64.9,12.7 63.4,12.7 63.4,13.2 68.4,13.2 68.4,12.7 66.9,12.7 66.9,4.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.1,1.7c0,0.7-0.6,1.3-1.3,1.3c-0.7,0-1.2-0.6-1.2-1.3c0-0.7,0.5-1.2,1.2-1.2C66.5,0.4,67.1,1,67.1,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78,12.7h1.5v0.4H76v-1.2c-0.6,1-1.6,1.4-2.9,1.4c-1,0-1.8-0.3-2.3-0.8c-0.6-0.6-0.7-1.1-0.7-3V4.9h-1.5V4.4 h3.5v5.2c0,2.2,0,2.6,0.3,2.9c0.2,0.2,0.6,0.4,1.1,0.4c0.8,0,1.5-0.4,1.9-1C75.9,11.1,76,10.4,76,8V4.9h-1.5V4.4H78V12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.6,4.9h-1.5V4.4h3.5v1.1c0.8-0.9,1.7-1.3,2.9-1.3c0.7,0,1.3,0.2,1.8,0.5c0.3,0.2,0.5,0.4,0.6,0.9 c0.7-1,1.7-1.5,3-1.5c0.9,0,1.7,0.3,2.1,0.8c0.3,0.4,0.4,1,0.4,2.2v5.5H96v0.4h-4.8v-0.4h1.3V7.3c0-1.5,0-1.8-0.4-2.1 c-0.2-0.2-0.5-0.3-0.9-0.3c-0.8,0-1.5,0.4-1.8,1.1C89.1,6.7,89,6.9,89,10.3v2.4h1.3v0.4h-4.7v-0.4H87V7.3c0-1.1-0.1-1.5-0.2-1.8 c-0.2-0.3-0.6-0.5-1-0.5C85,4.9,84.2,5.4,84,6c-0.3,0.6-0.4,1.7-0.4,4.3v2.4h1.3v0.4h-4.8v-0.4h1.5V4.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMillennium);
export default __webpack_public_path__ + "static/media/millennium.d86d319fa545b721c0a87ff83993e70c.svg";
export { ForwardRef as ReactComponent };